export const thickness = 1;
